<main class="processo-list">
  <app-processo-list *ngIf="currentMenu?.hasSei" [currentService]="seiService" route="sei"></app-processo-list>
  <app-processo-list *ngIf="currentMenu?.hasProa" [currentService]="proaService" route="proa"></app-processo-list>
  <h3 *ngIf="!currentMenu?.hasSei && !currentMenu?.hasProa">Não possui integrações</h3>
</main>